/**
 * Convert a percentage value (e.g., 5) to decimal format (e.g., 0.05) for API storage.
 */
export const toDecimal = (value: number | null): number | null => {
  if (value === null || value === undefined) return null;
  return Number((value / 100).toFixed(4));
};

/**
 * Convert a decimal value (e.g., 0.05) to percentage format (e.g., 5) for display.
 */
export const toPercentage = (value: number | null): number | null => {
  if (value === null || value === undefined) return null;
  return Number((value * 100).toFixed(2));
};

/**
 * Round a number to 2 decimal places, avoiding JS floating point artifacts
 * (e.g. 0.1 + 0.2 = 0.30000000000000004).
 */
export const roundTo2dp = (value: number): number => Number(value.toFixed(2));
